import { render, staticRenderFns } from "./GroupContainer.vue?vue&type=template&id=382e3da8&scoped=true&"
import script from "./GroupContainer.vue?vue&type=script&lang=js&"
export * from "./GroupContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e3da8",
  null
  
)

export default component.exports